import { environmentOM4ABase } from '@env/environment.om4a'

export const environmentOM4ADev = {
  ...environmentOM4ABase,
  apiUrl: 'https://api.openmod4africadev.hevs.ch/api',
  geoserverUrl: 'https://geoserver.openmod4africadev.hevs.ch/geoserver/',
  geoserverWorkspace: '',
  keycloakUrl: 'https://auth.openmod4africadev.hevs.ch',
  keycloakRealm: 'openmod4africa-dev',
  integrationServerUrl: 'https://api.openmod4africadev.hevs.ch/integration/',
  matomoTrackerUrl: 'https://analytics.citiwattsdev.hevs.ch/',
  matomoSiteId: '8',
}

export const environment = environmentOM4ADev
